import { IdentityManager } from 'miragejs';

function isNumber(n) {
  return (+n).toString() === n.toString();
}

export default class ReusableIdsIdentityManager extends IdentityManager {
  set(n) {
    if (isNumber(n) && +n >= this._nextId) {
      this._nextId = +n + 1;
    }

    this._ids[n] = true;
  }
}
